// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-custom-gray[data-v-5aaa8971] {\n  background-color: #f7f7f7;\n}", ""]);
// Exports
module.exports = exports;
